import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { Request } from 'commons/utils/request'

const deleteFile = (id: number) => Request.delete(Request.urls.bank.documentFile, { id })

export const useDeleteDocumentPeriodFile: WriteHook<number, void> = (id) =>
  useMutationManager<number, void>(deleteFile, id)
